import { States } from 'safe'
import {
  AccountTypes,
  ADD_ACCOUNT,
  CLEAN_TRANSACTIONS,
  DELETE_ACCOUNT,
  SET_ACCOUNTS,
  SET_ACCOUNT_VISIBLE,
  SET_MOVEMENT_ACCOUNT,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_BALANCE,
} from '../actions/actionTypes'

const initialState: States.Account = {
  accounts: [],
  transactions: [],
  numberOfPages: 0,
}

const accountReducer = (state = initialState, action: AccountTypes): States.Account => {
  switch (action.type) {
    case SET_ACCOUNTS:
      return { ...state, accounts: action.payload }
    case ADD_ACCOUNT:
      return { ...state, accounts: [...state.accounts, action.payload] }
    case UPDATE_ACCOUNT:
      return {
        ...state,
        accounts: state.accounts.map((account) =>
          account.id === action.payload.id ? action.payload : account
        ),
      }
    case DELETE_ACCOUNT:
      return {
        ...state,
        accounts: state.accounts.filter(
          (account) => account.id !== action.payload
        ),
      }
    case SET_ACCOUNT_VISIBLE:
      return {
        ...state,
        accounts: state.accounts.map((account) => {
          if (account.id === action.payload.id) {
            account.accountVisible = action.payload.visible
          }
          return account
        }),
      }
    case UPDATE_ACCOUNT_BALANCE:
      let stateCopy = [...state.accounts]
      let idx = stateCopy.findIndex((state) => state.id === action.payload.id)
      stateCopy[idx].balance = action.payload.amount
      return {
        ...state,
        accounts: stateCopy,
      }
    case SET_MOVEMENT_ACCOUNT:
      return {
        ...state,
        transactions: action.payload.transactions,
        numberOfPages: action.payload.numberOfPages,
      }
    case CLEAN_TRANSACTIONS:
      return {
        ...state,
        transactions: [],
      }
    default:
      return state
  }
}

export default accountReducer